<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">Request access</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <div class="mb-3 row">
      <label for="name" class="col-3 col-form-label">Full name</label>
      <div class="col-9">
        <input
          id="name"
          formControlName="name"
          class="form-control"
          type="text"
        />
        <hlu-validation-message
          [validationControl]="form.get('name')"
          validationName="required"
          errorMessage="Full name is required"
        >
        </hlu-validation-message>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="companyName" class="col-3 col-form-label">Company name</label>
      <div class="col-9">
        <input
          id="companyName"
          formControlName="companyName"
          class="form-control"
          type="text"
        />
        <hlu-validation-message
          [validationControl]="form.get('companyName')"
          validationName="required"
          errorMessage="Company name is required"
        >
        </hlu-validation-message>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="email" class="col-3 col-form-label">Email address</label>
      <div class="col-9">
        <input
          id="email"
          formControlName="email"
          class="form-control"
          type="text"
        />
        <hlu-validation-message
          [validationControl]="form.get('email')"
          validationName="required"
          errorMessage="Email address is required"
        >
        </hlu-validation-message>
        <hlu-validation-message
          [validationControl]="form.get('email')"
          validationName="email"
          errorMessage="Must be a valid email address"
        >
        </hlu-validation-message>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="phoneNumber" class="col-3 col-form-label">Phone number</label>
      <div class="col-9">
        <input
          id="phoneNumber"
          formControlName="phoneNumber"
          class="form-control"
          type="text"
        />
        <hlu-validation-message
          [validationControl]="form.get('phoneNumber')"
          validationName="required"
          errorMessage="Phone number is required"
        >
        </hlu-validation-message>
        <hlu-validation-message
          [validationControl]="form.get('phoneNumber')"
          validationName="validCountryPhone"
          errorMessage="Must be a valid UK phone number"
        >
        </hlu-validation-message>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid">
      Send
    </button>
  </div>
</form>
